import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ShortObject} from '../../project-misc/data/project/short-json-object';
import {ModifierField} from './modifier-field';
import {PricingMiscItem} from './misc-item/pricing-misc-item';
import {PricingCategory} from './pricing-category';


@JsonObject('model.CategoryModifier')
export class CategoryModifier extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(Number, 'qtyPerItem ')
  qtyPerItem?: number

  @JsonProperty(Boolean, 'defaultValue')
  defaultValue?: boolean

  @JsonProperty(PricingCategory, 'affectingCategory')
  affectingCategory?: PricingCategory

  @JsonProperty([PricingCategory], 'owningCategories')
  owningCategories?: PricingCategory[]

  @JsonProperty(String, 'preset')
  preset?: string

  @JsonProperty([ModifierField], 'fields')
  fields?: ModifierField[] = []

  @JsonProperty(PricingMiscItem, 'misc')
  misc?: PricingMiscItem
}

